import { AuthConstants } from "./constants";
import { requestJSON } from "@redux";
import { checkJsonProp } from "@utilities";

let user = JSON.parse(sessionStorage.getItem("user")),
  logged = user ? true : false;

export const getToken = user => {
  let access_token = checkJsonProp(user, "token");
  return "Bearer " + access_token;
};

if (user) {
  if (requestJSON) {
    requestJSON.defaults.headers.common["Authorization"] = getToken(user);
  }
}

export const AuthReducers = function(state = { logged }, action) {
  switch (action.type) {
    case AuthConstants.START_LOGIN_REQUEST:
      return {
        ...state,
        sendAuth: true,
        sendStartLogin: true,
        startLogin: null,
        logged: false
      };
    case AuthConstants.START_LOGIN_SUCCESS:
      sessionStorage.setItem("token", JSON.stringify(action.payload));
      return {
        ...state,
        sendAuth: false,
        sendStartLogin: false,
        startLogin: action.payload
      };
    case AuthConstants.START_LOGIN_ERROR:
      return {
        ...state,
        sendAuth: false,
        sendStartLogin: false,
        errors: action.error
      };
    case AuthConstants.CHECK_SCA_REQUEST:
      return {
        ...state,
        sendAuth: true
      };
    case AuthConstants.CHECK_SCA_SUCCESS:
      if (action.payload.status === "Success") {
        sessionStorage.setItem("user", JSON.stringify(action.payload));
        requestJSON.defaults.headers.common["Authorization"] = getToken(action.payload);
        logged = true;
      }
      if (action.payload.status === "SelectCompany") {
        sessionStorage.setItem("token", JSON.stringify(action.payload));
        requestJSON.defaults.headers.common["Authorization"] = getToken(action.payload);
      }
      return {
        ...state,
        sendAuth: false,
        checkSca: action.payload,
        logged
      };
    case AuthConstants.CHECK_SCA_ERROR:
      return {
        ...state,
        sendAuth: false,
        errors: action.error
      };
    case AuthConstants.SELECT_IDENTIFICATION_REQUEST:
      return {
        ...state,
        sendAuth: true,
        isLoadingSelectId: true,
        selectIdentification: null
      };
    case AuthConstants.SELECT_IDENTIFICATION_SUCCESS:
      if (action.payload.status === "Success") {
        sessionStorage.setItem("user", JSON.stringify(action.payload));
        requestJSON.defaults.headers.common["Authorization"] = getToken(action.payload);
        logged = true;
      }
      return {
        ...state,
        sendAuth: false,
        isLoadingSelectId: false,
        selectIdentification: action.payload,
        logged
      };
    case AuthConstants.SELECT_IDENTIFICATION_ERROR:
      return {
        ...state,
        sendAuth: false,
        isLoadingSelectId: false,
        errors: action.error
      };
    case AuthConstants.RESET_LOGIN:
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("token");
      return {
        ...state,
        sendAuth: false,
        sendStartLogin: false,
        startLogin: undefined,
        checkSca: undefined,
        logged: false
      };
    case AuthConstants.GET_IDENTIFICATION_URL_REQUEST:
      return {
        ...state,
        sendAuth: true,
        identificationUrl: null
      };
    case AuthConstants.GET_IDENTIFICATION_URL_SUCCESS:
      return {
        ...state,
        sendAuth: false,
        identificationUrl: action.payload
      };
    case AuthConstants.GET_IDENTIFICATION_URL_ERROR:
      return {
        ...state,
        sendAuth: false
      };
    case AuthConstants.REFRESH_TOKEN_REQUEST:
      sessionStorage.removeItem("user");
      return {
        ...state,
        sendAuth: true,
        refreshToken: null,
        checkSca: null,
        isRefreshTokenLoading: true
      };
    case AuthConstants.REFRESH_TOKEN_SUCCESS:
      sessionStorage.setItem("user", JSON.stringify(action.payload));
      requestJSON.defaults.headers.common["Authorization"] = getToken(action.payload);
      return {
        ...state,
        sendAuth: false,
        isRefreshTokenLoading: false,
        refreshToken: action.payload
      };
    case AuthConstants.REFRESH_TOKEN_ERROR:
      return {
        ...state,
        sendAuth: false,
        isRefreshTokenLoading: false,
        refreshToken: null,
        errors: action.error
      };
    default:
      return state;
  }
};
